import { ActivityNames } from "../types";

export const activityNames: ActivityNames = {
    'rock_climbing': 'Escalade',
    'skitouring': 'Ski de randonnée',
    'hiking': 'Randonnée',
    'mountain_climbing': 'Rocher Haute Montagne',
    'snow_ice_mixed': 'Rocher Mixte Neige/Glace',
    'ice_climbing': 'Rocher Cascade de Glace',
    'snowshoeing': 'Randonnée avec raquettes',
    'mountain_biking': 'Vélo de Montagne',
    'via_ferrata': 'Via Ferrata',
    'slacklining': 'Slackline'
};

export const activityEmojis: Record<string, string> = {
    'rock_climbing': '🧗',
    'skitouring': '⛷️',
    'hiking': '🥾',
    'mountain_climbing': '🏔️',
    'snow_ice_mixed': '❄️',
    'ice_climbing': '🧊',
    'snowshoeing': '🎿',
    'mountain_biking': '🚵',
    'via_ferrata': '⛓️',
    'slacklining': '🪢'
};

export const activityLabels: Record<string, string> = {
    'rock_climbing': '🧗 Escalade',
    'hiking': '🥾 Randonnée',
    'skitouring': '⛷️ Ski de randonnée',
    'mountain_climbing': '🏔️ Rocher Haute Montagne',
    'snow_ice_mixed': '❄️ Mixte neige/glace',
    'ice_climbing': '🧊 Cascade de glace',
    'snowshoeing': '🎿 Raquettes',
    'mountain_biking': '🚵 VTT',
    'via_ferrata': '🪢 Via ferrata',
    'slacklining': '🎪 Slackline'
};